import AppACL from '@/plugins/acl/ACL'

const Menu = [
  { header: 'Secciones' },
  {
    text: 'Dashboard',
    icon: 'dashboard',
    to: '/dashboard',
    roles: [
      AppACL.ROLE.GEM,
      AppACL.ROLE.ADM,
      AppACL.ROLE.COL,
      AppACL.ROLE.DIST,
      AppACL.ROLE.LAB,
    ],
  },
  {
    text: 'Laboratorios',
    group: 'laboratorios',
    icon: 'add_to_queue',
    roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
    children: [
      { to: '/laboratorios/listado', text: 'Listado' },
      { to: '/laboratorios/nuevo', text: 'Nuevo' },
    ],
  },
  {
    text: 'Distribuidores',
    group: 'distribuidores',
    icon: 'work',
    roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
    children: [
      { to: '/distribuidores/listado', text: 'Listado' },
      { to: '/distribuidores/nuevo', text: 'Nuevo' },
    ],
  },
  {
    text: 'Productos',
    group: 'productos',
    icon: 'file_copy',
    roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
    children: [
      { to: '/productos/listado', text: 'Listado' },
      { to: '/productos/nuevo', text: 'Nuevo' },
      { to: '/productos/expirados', text: 'Expirados' },
    ],
  },
  {
    text: 'Usuarios',
    group: 'usuarios',
    icon: 'people',
    roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
    children: [
      { to: '/usuarios/listado', text: 'Listado' },
      { to: '/usuarios/nuevo', text: 'Nuevo' },
    ],
  },
  {
    text: 'Facturas',
    group: 'facturas',
    icon: 'credit_card',
    roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
    children: [
      { to: '/facturas/listado', text: 'Listado' },
      { to: '/facturas/nuevo', text: 'Nuevo' },
    ],
  },
  {
    text: 'Transit',
    group: 'transit',
    icon: 'assignment',
    roles: [AppACL.ROLE.GEM, AppACL.ROLE.COL, AppACL.ROLE.ADM],
    children: [
      { to: '/transit/facturas', text: 'Facturas para Procesar' },
      { to: '/transit/f&d', text: 'F&D' },
      { to: '/transit/aprobadas', text: 'Aprobadas' },
      { to: '/transit/rechazadas', text: 'Rechazadas' },
      { to: '/transit/pago-de-impuestos', text: 'Pago de Impuestos' },
      { to: '/transit/entregas', text: 'Entregas' },
    ],
  },
  {
    text: 'Transit',
    group: 'transit',
    icon: 'assignment',
    roles: [AppACL.ROLE.DIST, AppACL.ROLE.LAB],
    children: [{ to: '/transit/ver-facturas', text: 'Ver Facturas' }],
  },
  {
    text: 'Transit',
    group: 'transit',
    icon: 'assignment',
    roles: [AppACL.ROLE.PAG],
    children: [{ to: '/transit/pago-de-impuestos', text: 'Pago de Impuestos' }],
  },
  {
    text: 'Transit',
    group: 'transit',
    icon: 'assignment',
    roles: [AppACL.ROLE.ENT],
    children: [{ to: '/transit/entregas', text: 'Entregas' }],
  },
  {
    text: 'Notificaciones',
    icon: 'add_alert',
    to: '/notificaciones',
    roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
  },
  {
    text: 'Logs',
    icon: 'notification_important',
    to: '/logs',
    roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
  },
]

export default Menu
